import * as React from "react";
import "./SPOTNotification.scss";

export interface FormFieldProps {
    active?: boolean;
    text: string | React.ReactNode;
    type: "warning" | "error";
    background?: "filled" | "none";
}

export const SPOTNotification: React.FC<FormFieldProps> = (props) => {
    const backgroundColor = props.background ? props.background : "filled";

    return (
        <div className="spot-notification">
            {props.active && (
                <div className={props.type + " " + backgroundColor}>
                    {props.type === "error" && <i className="icon-attention-round"></i>}
                    {props.type === "warning" && <i className="icon-attention"></i>}
                    <p>{props.text}</p>
                </div>
            )}
        </div>
    );
};
